import { __rest } from "tslib";
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import React, { useState } from 'react';
import zhCN from 'date-fns/locale/zh-CN';
import moment, { isMoment } from 'moment';
import { Input } from 'antd';
import classNames from 'classnames';
import styles from './schedule_date_picker.module.scss';
registerLocale('zhCN', zhCN);
setDefaultLocale('zhCN');
export const CustomDatePickerInput = React.forwardRef((props, ref) => React.createElement(Input, Object.assign({ ref: ref }, props)));
const customHeader = ({ date, decreaseMonth, increaseMonth, }) => (React.createElement("div", { className: styles.header },
    React.createElement("i", { onClick: decreaseMonth, className: classNames(styles.arrow, styles.left) }),
    React.createElement("span", { className: styles.date }, moment(date).format('yyyy年 MM月')),
    React.createElement("i", { onClick: increaseMonth, className: classNames(styles.arrow, styles.right) })));
const PreSetDatePicker = props => {
    const { dateFormat = 'yyyy-MM-dd', onChange, value, style, allowClear = true, className, filterDate, onKeyDown, popperStrategy } = props, rest = __rest(props, ["dateFormat", "onChange", "value", "style", "allowClear", "className", "filterDate", "onKeyDown", "popperStrategy"]);
    const [date, setDate] = useState(moment.isMoment(value) ? value.toDate() : undefined);
    const dateChange = (d) => {
        if (onChange) {
            onChange(d ? moment(d) : null);
        }
        setDate(d);
    };
    return (React.createElement("div", { className: styles.reactDatepickerWrapper },
        React.createElement(DatePicker, Object.assign({ onChange: dateChange, selected: isMoment(value) ? value.toDate() : date, closeOnScroll: () => true, filterDate: filterDate, onKeyDown: onKeyDown }, rest, { placeholderText: rest.placeholder, locale: "zhCN", dateFormat: dateFormat, showPopperArrow: false, customInput: React.createElement(CustomDatePickerInput, { disabled: rest.disabled, className: className, style: style }), popperProps: { strategy: popperStrategy }, popperModifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        altAxis: true,
                    },
                },
                {
                    name: 'flip',
                    options: {
                        altBoundary: true,
                    },
                },
            ], isClearable: isMoment(value) && allowClear && !rest.disabled, renderCustomHeader: customHeader }))));
};
export default PreSetDatePicker;
